import { useState } from 'react';
import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileCollectorHelpLimitedEditionsPage() {
  const t = useTranslations('collectors_help.limited_editions');
  const [openSections, setOpenSections] = useState({
    whatAreLimitedEditions: false,
    pricesAndSizes: false,
    affectOriginalArtwork: false,
    qualityControl: false,
    certifiedAndNumbered: false,
    shippingTimelines: false,
    returningLimitedEditions: false,
    originalRemoved: false,
    maintainingLimitedEditions: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/collector-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whatAreLimitedEditions')}
            aria-expanded={openSections.whatAreLimitedEditions}
          >
            <h2>{t('sections.what_are.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whatAreLimitedEditions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatAreLimitedEditions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.what_are.p1')}</p>
              <p>{t('sections.what_are.p2')}</p>
              <ul>
                <li>{t('sections.what_are.list_1')}</li>
                <li>{t('sections.what_are.list_2')}</li>
                <li>{t('sections.what_are.list_3')}</li>
                <li>{t('sections.what_are.list_4')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('pricesAndSizes')}
            aria-expanded={openSections.pricesAndSizes}
          >
            <h2>{t('sections.prices_sizes.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.pricesAndSizes ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.pricesAndSizes && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.prices_sizes.p1')}</p>
              <ul>
                <li>{t('sections.prices_sizes.list_1')}</li>
                <li>{t('sections.prices_sizes.list_2')}</li>
                <li>{t('sections.prices_sizes.list_3')}</li>
              </ul>

              <div className="artist-help-category__note">
                <h3>{t('sections.prices_sizes.notes_title')}</h3>
                <ul>
                  <li>{t('sections.prices_sizes.list_4')}</li>
                  <li>{t('sections.prices_sizes.list_5')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('affectOriginalArtwork')}
            aria-expanded={openSections.affectOriginalArtwork}
          >
            <h2>{t('sections.affect_original.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.affectOriginalArtwork ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.affectOriginalArtwork && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.affect_original.p1')}</p>
              <ul>
                <li>{t('sections.affect_original.list_1')}</li>
                <li>{t('sections.affect_original.list_2')}</li>
                <li>{t('sections.affect_original.list_3')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('qualityControl')}
            aria-expanded={openSections.qualityControl}
          >
            <h2>{t('sections.quality_control.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.qualityControl ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.qualityControl && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.quality_control.p1')}</p>
              <p>{t('sections.quality_control.p2')}</p>
              <p>{t('sections.quality_control.p3')}</p>
              <ul>
                <li>{t('sections.quality_control.list_1')}</li>
                <li>{t('sections.quality_control.list_2')}</li>
                <li>{t('sections.quality_control.list_3')}</li>
              </ul>
              <p>{t('sections.quality_control.p4')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('certifiedAndNumbered')}
            aria-expanded={openSections.certifiedAndNumbered}
          >
            <h2>{t('sections.certified_numbered.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.certifiedAndNumbered ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.certifiedAndNumbered && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.certified_numbered.p1')}</p>
              <p>{t('sections.certified_numbered.p2')}</p>
              <ul>
                <li>{t('sections.certified_numbered.list_1')}</li>
                <li>{t('sections.certified_numbered.list_2')}</li>
                <li>{t('sections.certified_numbered.list_3')}</li>
              </ul>
              <p>{t('sections.certified_numbered.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('shippingTimelines')}
            aria-expanded={openSections.shippingTimelines}
          >
            <h2>{t('sections.shipping_timelines.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.shippingTimelines ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.shippingTimelines && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.shipping_timelines.p1')}</p>
              <p>{t('sections.shipping_timelines.p2')}</p>
              <ul>
                <li>{t('sections.shipping_timelines.list_1')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('returningLimitedEditions')}
            aria-expanded={openSections.returningLimitedEditions}
          >
            <h2>{t('sections.returning.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.returningLimitedEditions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.returningLimitedEditions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.returning.p1')}</p>
              <ul>
                <li>
                  {t('sections.returning.list_1_pre')}{' '}
                  <Link
                    to="/limited-editions-return-and-refund-policy"
                    state={{ fromPath: '/profile/collector-help/limited-editions' }}
                  >
                    {t('sections.returning.link_label')}
                  </Link>{' '}
                  {t('sections.returning.list_1_post')}
                </li>
              </ul>
              <p>{t('sections.returning.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('originalRemoved')}
            aria-expanded={openSections.originalRemoved}
          >
            <h2>{t('sections.original_removed.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.originalRemoved ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.originalRemoved && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.original_removed.p1')}</p>
              <ul>
                <li>{t('sections.original_removed.list_1')}</li>
              </ul>
              <p>{t('sections.original_removed.p2')}</p>
              <ul>
                <li>{t('sections.original_removed.list_2')}</li>
              </ul>
              <p>{t('sections.original_removed.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('maintainingLimitedEditions')}
            aria-expanded={openSections.maintainingLimitedEditions}
          >
            <h2>{t('sections.maintaining.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.maintainingLimitedEditions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.maintainingLimitedEditions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.maintaining.p1')}</p>
              <ul>
                <li>{t('sections.maintaining.list_1')}</li>
                <li>{t('sections.maintaining.list_2')}</li>
                <li>{t('sections.maintaining.list_3')}</li>
              </ul>
              <p>{t('sections.maintaining.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
